module.exports = __webpack_public_path__ + "static/media/icon-puzzle.5f7a0ed5.svg";